var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8047 3.52864C14.0651 3.78899 14.0651 4.2111 13.8047 4.47145L6.4714 11.8048C6.21106 12.0651 5.78894 12.0651 5.5286 11.8048L2.19526 8.47145C1.93491 8.2111 1.93491 7.78899 2.19526 7.52864C2.45561 7.26829 2.87772 7.26829 3.13807 7.52864L6 10.3906L12.8619 3.52864C13.1223 3.26829 13.5444 3.26829 13.8047 3.52864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/complete-icon.174d68a2d2b78f91c5abf093f74d63e8.svg";
export { ForwardRef as ReactComponent };